import { getFormatedDate } from 'helpers';
import { useCallback } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { showSkeletonReport } from '@store/reports/actions';

import {
  deleteReport,
  fetchReports,
  setCurrentPage,
  filterReports,
  setInitialState,
  setReportsRangeToShow,
  createReport,
  openFlux,
  openSpinner,
  setFilterReportsByType,
  resetFilter,
  scheduledReport,
} from '@store/reports/actions';

const useReports = () => {
  const dispatch = useDispatch();
  const {
    reports: {
      reports,
      filters = {},
      pagination,
      reportsRangeToShow,
      newReportModal,
      reportsTypeToShow,
    },
    login: {
      merchant: {
        wallet_info: { creditor_account_id: accountId },
      },
    },
  } = useSelector((state) => state);

  const doShowSkeletonReport = () => {
    dispatch(showSkeletonReport());
  };

  const doFetchReports = useCallback(() => {
    dispatch(showSkeletonReport());
    dispatch(fetchReports(accountId));
  }, []);

  const doCreateReport = useCallback((data) => {
    dispatch(openFlux());
    dispatch(openSpinner());
    const payload = {
      account_id: accountId,
      type: 'DATA_RANGE',
      start_date: getFormatedDate(data.start, 'yyyy-MM-dd'),
      end_date: getFormatedDate(data.end, 'yyyy-MM-dd'),
    };
    dispatch(createReport(payload));
  }, []);

  const doScheduledReport = useCallback((value) => {
    dispatch(openFlux());
    dispatch(openSpinner());
    const payload = {
      account_id: accountId,
      type: value,
    };
    dispatch(scheduledReport(payload));
  }, []);

  const doSetCurrentPage = useCallback((nextPage) => {
    dispatch(setCurrentPage(nextPage));
  }, []);

  const doSetReportsRangeToShow = useCallback(
    (range) => dispatch(setReportsRangeToShow(range)),
    []
  );

  const doSetReportsTypeToShow = useCallback((type) => dispatch(setFilterReportsByType(type)), []);
  const doSetInitialState = useCallback((nextPage) => dispatch(setInitialState(nextPage)), []);
  const doDeleteReport = useCallback((id) => dispatch(deleteReport(id)), []);

  const doSetFilters = useCallback((filter) => dispatch(filterReports({ accountId, filter })), []);
  const doCleanFilters = useCallback(() => dispatch(resetFilter()), []);

  return {
    filters,
    pagination,
    reports,
    reportsRangeToShow,
    newReportModal,
    reportsTypeToShow,
    deleteReport: doDeleteReport,
    createReport: doCreateReport,
    scheduledReport: doScheduledReport,
    fetchReports: doFetchReports,
    setCurrentPage: doSetCurrentPage,
    setInitialState: doSetInitialState,
    setReportsRangeToShow: doSetReportsRangeToShow,
    setFilterReportsByType: doSetReportsTypeToShow,
    setFilters: doSetFilters,
    cleanFilters: doCleanFilters,
    showSkeletonReport: doShowSkeletonReport,
  };
};

export default useReports;
